<script>
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import { FormMixinDefault } from "./form-mixin-default";

export default {
  name: "FormFactory",
  mixins: [validationMixin, FormMixinDefault],
  // Injecting dependencies makes it
  // possible or reuse this component
  // for all kinds of content types.
  inject: ["handleSubmit", "fetchData"],
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    hasPadding: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    isFormSubmit() {
      this.submit();
    },
  },
  computed: mapGetters({
    isFormSubmit: "forms/isFormSubmit",
  }),
};
</script>

<template>
  <form class="form-factory" ref="form" @submit.prevent="submit">
    <Component
      v-for="(field, i) in fieldsWithDefaults"
      :key="i"
      :ref="field.attrs.name"
      :is="field.component"
      :error="{
        status: $v.data[field.attrs.name],
        messages: field.errorMessages,
      }"
      class="mb-4 first:mt-0"
      v-bind="{ ...field.attrs }"
      v-model="data[field.attrs.name]"
      @blur="$v.data[field.attrs.name].$touch()"
      @input="$v.data[field.attrs.name].$touch()"
      @change="$v.data[field.attrs.name].$touch()"
      @keyup="
        handleNextField(
          $refs[field.attrs.name],
          field.attrs,
          $v.data[field.attrs.name]
        )
      "
    />
    <span class="block py-4" v-if="hasPadding"></span>
    <slot />
    <div
      class="generalError text-error text-center md:text-left"
      v-if="generalError"
    >
      {{ getMessageError }}
    </div>
    <input type="submit" value="" class="hidden" />
  </form>
</template>
